import Decimal from 'decimal.js';

export const fixMath = {
    add: (a: number, b: number): number =>
        new Decimal(a).plus(b).toNumber(),

    multiply: (a: number, b: number): number =>
        new Decimal(a).times(b).toNumber(),

    subtract: (a: number, b: number): number =>
        new Decimal(a).minus(b).toNumber(),

    divide: (a: number, b: number): number =>
        new Decimal(a).div(b).toNumber(),
};